export const NO_SIDEBAR = "no-sidebar";

export default {
  NO_SIDEBAR,
};
